// import React from 'react';
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import Logo from "../navbar/UdayaSolutionLogo.png";
import Logo1 from "./footerimg1.png";
import Logo2 from "./footerimg2.png";
import Logo3 from "./footerimg3.png";
import Logo4 from "./twitter.png";
import Logo5 from "./fb.png";
import Logo6 from "./insta.png";
import Logo7 from "./linkedin.png";
// import Logo8 from "./footerlogo5.png";
import "./footer.css";
const Footer = () => {
  return (
    <MDBFooter bgColor="dark" className="text-center text-lg-start text-white">
      {/* <section className="footersection d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
        <div className="me-5 d-none d-lg-block">
          <span>Get connected with us on social networks:</span>
        </div>

        <div>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="facebook-f" />
          </a>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="twitter" />
          </a>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="google" />
          </a>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="instagram" />
          </a>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="linkedin" />
          </a>
          <a href="" className="me-4 text-reset">
            <MDBIcon color="secondary" fab icon="github" />
          </a>
        </div>
      </section> */}

      <section className="footersection pt-5 pb-5">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="5" className="mx-auto mb-4">
              <h6
                className="text-uppercase fw-bold mb-4"
                style={{ textAlign: "justify" }}
              >
                {/* <MDBIcon color="secondary" icon="gem" className="me-3" /> */}
                <img
                  src={Logo}
                  style={{ width: "4rem" }}
                  className="px-1"
                  alt="Logo"
                />{" "}
                {/* Udaya Solutions */}
              </h6>
              <p className="dissapper">
                Moving ahead with the advancements in the professional world,
                Udaya Solution provides the best recruitment services. Based in
                Bhubaneswar and Gurgaon, we offer the best recruitment solutions
                to our clients.
              </p>
              <p
                className="text-uppercase fw-bold mb-4 footeritems"
                style={{ textAlign: "left" }}
              >
                {/* <MDBIcon color="secondary" icon="gem" className="me-3" /> */}
                <img src={Logo1} className="px-1" alt="Logo" />
                <a href="#" className="white">
                  3010, 3rd Floor, Twin City Tower, NH-16, Pahala, Bhubaneswar,
                  Odisha 752101
                </a>
              </p>
              <p className="text-uppercase fw-bold mb-4 footeritems">
                {/* <MDBIcon color="secondary" icon="gem" className="me-3" /> */}
                <img src={Logo2} className="px-1" alt="Logo2" />
                <a href="#" className="white">
                  support@udayasolutions.com
                </a>
              </p>
              <p className="text-uppercase fw-bold mb-4 footeritems">
                {/* <MDBIcon color="secondary" icon="gem" className="me-3" /> */}
                <img src={Logo3} className="px-1" alt="Logo3" />
                <a href="#" className="white">
                  +91 093387 68736
                </a>
              </p>
            </MDBCol>
            {/* <div className=""> */}
            <MDBCol className="footericons logos">
              <img src={Logo4} alt="Logo4" />
              <img src={Logo5} alt="Logo4" />
              <img src={Logo6} alt="Logo4" />
              <img src={Logo7} alt="Logo4" />
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4 dissapper">
              <h6 className="text-uppercase fw-bold mb-4">Company</h6>
              <p>
                <a href="/about" className="text-reset">
                  About
                </a>
              </p>
              <p>
                <a href="/contact" className="text-reset">
                  Contact
                </a>
              </p>
              <p>
                <a href="/jobs" className="text-reset">
                  Careers
                </a>
              </p>
            </MDBCol>

            <MDBCol
              md="3"
              lg="2"
              xl="2"
              className="mx-auto mb-4 customerSupport"
            >
              <h6 className="text-uppercase fw-bold mb-4 dissapper">Help</h6>
              <p className="textfooter">
                <a href="/TermsAndConditions" className="text-reset">
                  Terms & Conditions
                </a>
              </p>
              <p className="textfooter">
                <a href="/privacyPolicy" className="text-reset">
                  Privacy Policy
                </a>
              </p>
            </MDBCol>
            <div className="footericons">© Udaya Solutions Private Limited</div>
            <MDBCol
              md="3"
              lg="2"
              xl="2"
              className="dissapper mx-auto mb-md-0 mb-4"
            >
              <h6 className="text-uppercase fw-bold mb-4">Services</h6>
              <p>
                <a href="/Services/Strategic_Staffing_Solution" className="text-reset">
                Strategic Staffing Solution
                </a>
              </p>
              <p>
                <a href="/Services/Executive_Hiring" className="text-reset">
                Executive Hiring
                </a>
              </p>
              <p>
                <a href="/Services/Market_Research" className="text-reset">
                Market Research
                </a>
              </p>
              <p>
                <a href="/Services/Survey" className="text-reset">
                Survey
                </a>
              </p>
              <p>
                <a href="/Services/Training_&_Development" className="text-reset">
              Training & Development
                </a>
              </p>
              <p>
                <a href="/Services/HR_Business_Benchmarking" className="text-reset">
                HR Business Benchmarking
                </a>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      {/* <div
        className="text-center p-4"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
      >
        © 2023 Copyright:
        <a className="text-reset fw-bold" href="https://mdbootstrap.com/">
          Student Rays
        </a>
      </div> */}
    </MDBFooter>
  );
};
export default Footer;
